import { GREEN, GREEN_TINT } from '../../../../components/choice-look'

// The wash cards' green (tint, border, tick) is the booking screen's one
// chosen look; car size, day, time and extras wear it too
// (components/choice-look.js, DESIGN.md §10).

export const styles = () => ({
  root: { display: 'flex', flexDirection: 'column', gap: 8 },
  cards: { display: 'flex', flexDirection: 'column', gap: 8 },
  card: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    width: '100%',
    padding: '12px 14px',
    borderRadius: 12,
    border: '1.5px solid #dbe2ea',
    background: '#fff',
    color: '#0f172a',
    fontFamily: 'inherit',
    textAlign: 'left',
    cursor: 'pointer',
    '&:hover': { borderColor: '#94a3b8' }
  },
  cardOn: { borderColor: GREEN, background: GREEN_TINT },
  cardCompact: { padding: '8px 12px' },
  tick: {
    width: 22,
    height: 22,
    borderRadius: '50%',
    border: '1.5px solid #cbd5e1',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#fff',
    flexShrink: 0
  },
  tickOn: { background: GREEN, borderColor: GREEN },
  body: { display: 'flex', flexDirection: 'column', gap: 2, flex: 1, minWidth: 0 },
  name: { fontFamily: "Poppins, 'Helvetica Neue', sans-serif", fontWeight: 700, fontSize: 15, lineHeight: 1.2 },
  // Not clamped: each line is what that wash adds over the others
  // (lib/wash-copy.js), and a clamp cut off exactly the part that differs.
  desc: { fontSize: 13, color: '#64748b', lineHeight: 1.3 },
  // "Large car +£20" under the description (19 Oct 2026).
  large: { fontSize: 'var(--fs-caption)', lineHeight: 'var(--lh-caption)', color: 'var(--mute)' },
  price: { fontFamily: "Poppins, 'Helvetica Neue', sans-serif", fontWeight: 700, fontSize: 16, color: GREEN, flexShrink: 0 },
  moreLink: {
    alignSelf: 'flex-start',
    display: 'inline-flex',
    alignItems: 'center',
    gap: 2,
    padding: '4px 0',
    border: 0,
    background: 'none',
    color: '#0f766e',
    fontFamily: 'inherit',
    fontSize: 14,
    fontWeight: 600,
    cursor: 'pointer'
  }
})
